import { AxiosStatic } from 'axios';

import { usePhoneCallStore } from 'src/stores/phoneCall';

import { AbstractPollingPhoneCallGatewayWithHangupFunctionalityStrategy } from 'src/components/phoneCall/phoneCallGateway/AbstractPollingPhoneCallGatewayWithHangupFunctionalityStrategy';
import { PollingPhoneCallGatewayWithHangupFunctionalityStrategy } from 'src/components/phoneCall/phoneCallGateway/PollingPhoneCallGatewayWithHangupFunctionalityStrategy';
import { sendGenericPostRequest } from 'src/components/phoneCall/phoneCallGateway/genericPostRequest/sendGenericPostRequest';

import { OutgoingCallConfigurationForTheUser } from 'src/models/phoneCall';

import { CommandBus } from 'src/util/command/CommandBus';
import { QueryStore } from 'src/util/query/QueryStore';

type PhoneCallStore = ReturnType<typeof usePhoneCallStore>;

export class GenericPostPollingPhoneCallGatewayWithHangupFunctionalityStrategy
	extends AbstractPollingPhoneCallGatewayWithHangupFunctionalityStrategy
	implements PollingPhoneCallGatewayWithHangupFunctionalityStrategy
{
	private readonly axios: AxiosStatic;
	private readonly outGoingCallConfigurationForTheUser: OutgoingCallConfigurationForTheUser;

	constructor(
		axios: AxiosStatic,
		phoneCallStore: PhoneCallStore,
		queryStore: QueryStore,
		commandBus: CommandBus,
		authenticatedUserId: number,
		outgoingCallConfigurationForTheUser: OutgoingCallConfigurationForTheUser
	) {
		super(phoneCallStore, queryStore, commandBus, authenticatedUserId);
		this.axios = axios;
		this.outGoingCallConfigurationForTheUser = outgoingCallConfigurationForTheUser;
	}

	public async makeCall(_: string, toNumber: string): Promise<null | string> {
		const timestamp = String(Math.floor(Date.now() / 1000));

		await sendGenericPostRequest(this.axios, this.outGoingCallConfigurationForTheUser.url_init as string, {
			number: toNumber,
			terminal: this.outGoingCallConfigurationForTheUser.terminal,
		});

		this.setActiveCallId(this.outGoingCallConfigurationForTheUser.terminal);

		return await this.nextOutgoingCallIdForACalledNumberAfterAGivenTimestamp(toNumber, timestamp);
	}

	public endCall(): void {
		sendGenericPostRequest(this.axios, this.outGoingCallConfigurationForTheUser.url_hangup as string, {
			terminal: this.outGoingCallConfigurationForTheUser.terminal,
		}).catch(() => {
			/* empty */
		});

		this.clearActiveCall();
	}
}
